import { render, staticRenderFns } from "./BaseIconText.vue?vue&type=template&id=a64c1e7e"
import script from "./BaseIconText.vue?vue&type=script&lang=ts"
export * from "./BaseIconText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports